var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountryIr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2858_7874)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2858_7874",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H26C26.9665 0.25 27.75 1.0335 27.75 2V18C27.75 18.9665 26.9665 19.75 26 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2858_7874)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.66667H28V0H0V6.66667Z",
    fill: "#38BB56"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20H28V13.3334H0V20Z",
    fill: "#DE1B27"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66659 5.33337H1.33325V6.66671H2.66659V5.33337ZM5.33325 5.33337H3.99992V6.66671H5.33325V5.33337ZM6.66659 5.33337H7.99992V6.66671H6.66659V5.33337ZM10.6666 5.33337H9.33325V6.66671H10.6666V5.33337ZM11.9999 5.33337H13.3333V6.66671H11.9999V5.33337ZM15.9999 5.33337H14.6666V6.66671H15.9999V5.33337ZM17.3333 5.33337H18.6666V6.66671H17.3333V5.33337ZM21.3333 5.33337H19.9999V6.66671H21.3333V5.33337ZM22.6666 5.33337H23.9999V6.66671H22.6666V5.33337ZM26.6666 5.33337H25.3333V6.66671H26.6666V5.33337ZM1.33325 13.3334H2.66659V14.6667H1.33325V13.3334ZM5.33325 13.3334H3.99992V14.6667H5.33325V13.3334ZM6.66659 13.3334H7.99992V14.6667H6.66659V13.3334ZM10.6666 13.3334H9.33325V14.6667H10.6666V13.3334ZM11.9999 13.3334H13.3333V14.6667H11.9999V13.3334ZM15.9999 13.3334H14.6666V14.6667H15.9999V13.3334ZM17.3333 13.3334H18.6666V14.6667H17.3333V13.3334ZM21.3333 13.3334H19.9999V14.6667H21.3333V13.3334ZM22.6666 13.3334H23.9999V14.6667H22.6666V13.3334ZM26.6666 13.3334H25.3333V14.6667H26.6666V13.3334Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_2858_7874",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6535 8.52112C12.252 8.88691 12 9.41402 12 9.99998C12 11.1045 12.8954 12 14 12C15.1046 12 16 11.1045 16 9.99998C16 9.42508 15.7574 8.90683 15.3691 8.542"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.2045 8.0283C11.6702 8.5151 11.3333 9.21867 11.3333 9.99998H12.6667C12.6667 9.60936 12.8338 9.25872 13.1025 9.01394L12.2045 8.0283ZM11.3333 9.99998C11.3333 11.4727 12.5272 12.6666 14 12.6666V11.3333C13.2636 11.3333 12.6667 10.7364 12.6667 9.99998H11.3333ZM14 12.6666C15.4728 12.6666 16.6667 11.4727 16.6667 9.99998H15.3333C15.3333 10.7364 14.7364 11.3333 14 11.3333V12.6666ZM16.6667 9.99998C16.6667 9.23349 16.3424 8.54167 15.8255 8.0561L14.9126 9.0279C15.1724 9.27199 15.3333 9.61666 15.3333 9.99998H16.6667Z",
    fill: "#D80915",
    mask: "url(#path-7-inside-1_2858_7874)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10C13.3333 9.63185 13.6317 9.33337 13.9999 9.33337C14.3681 9.33337 14.6666 9.63185 14.6666 10V11.3334C14.6666 11.7016 14.3681 12 13.9999 12C13.6317 12 13.3333 11.7016 13.3333 11.3334V10Z",
    fill: "#D80915"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2858_7874"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H26C27.1046 0 28 0.895431 28 2V18C28 19.1046 27.1046 20 26 20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryIr);
export default __webpack_public_path__ + "static/media/Country=IR.70ea7d0c09f4cee2f7890bab5b108826.svg";
export { ForwardRef as ReactComponent };